import {fetchRemoteResult} from '../../../Core/Api/api-util';
import securityApi from '../../../Core/Util/security';

const apiControllerEndpoint = '/api/Newsroom/';

const validateNewsroomPermission = (grantType) => {
    return securityApi.validatePermission(securityApi.Permissions.Newsroom, grantType);
};

export default {
    listNewsroomItems(){
        return fetchRemoteResult(apiControllerEndpoint);
    },
    getNewsroomItem(id){
        return fetchRemoteResult(`${apiControllerEndpoint}${id}`);
    },
    createNewsroomItem(model){
        return fetchRemoteResult(`${apiControllerEndpoint}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(model)
        });
    },
    editNewsroomItem(model){
        return fetchRemoteResult(`${apiControllerEndpoint}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(model)
        });
    },
    deleteNewsroomItem(id){
        return fetchRemoteResult(`${apiControllerEndpoint}${id}`, {
            method: 'DELETE'
        });
    },
    
    validateReadPermission(){
        return validateNewsroomPermission(securityApi.PermissionGrantTypes.Read);
    },
    validateWritePermission(){
        return validateNewsroomPermission(securityApi.PermissionGrantTypes.Write);
    },
    validateDeletePermission(){
        return validateNewsroomPermission(securityApi.PermissionGrantTypes.Delete);
    }
}
